export default __webpack_public_path__ + "static/ProValue_2@992-5c62fc2255246ae149c558cde8a71dc4.webp";